import React from "react";
import { createPortal } from "react-dom";
import { getDateRange } from "../../hooks/useWeeklyPlan";

const DAYS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13];

/** Get day label: "Heute" for day 0, else weekday */
function getDayLabel(dayIndex, date) {
  if (dayIndex === 0) return "Heute";
  return date.toLocaleDateString("de-CH", { weekday: "short" });
}

export default function SlotPickerModal({ onSelect, onClose }) {
  const { dayDates } = getDateRange();

  const handleDayClick = (day) => {
    onSelect(day);
    onClose();
  };

  const modalContent = (
    <div
      className="plan-modal-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="Tag im Plan wählen"
    >
      <div className="plan-modal" onClick={(e) => e.stopPropagation()}>
        <div className="plan-modal-header">
          <h3>Welcher Tag?</h3>
          <button
            type="button"
            className="plan-modal-close"
            onClick={onClose}
            aria-label="Schliessen"
          >
            ×
          </button>
        </div>
        <div className="slot-picker-content">
          <div className="slot-picker-day-only-grid">
            {DAYS.map((day) => (
              <button
                key={day}
                type="button"
                className="slot-picker-day-cell"
                onClick={() => handleDayClick(day)}
                aria-label={`${getDayLabel(day, dayDates[day])} ${dayDates[day].toLocaleDateString("de-CH", {
                  day: "numeric",
                  month: "short",
                })}`}
              >
                <span className="slot-picker-day-cell-label">{getDayLabel(day, dayDates[day])}</span>
                <span className="slot-picker-day-cell-date">
                  {dayDates[day].toLocaleDateString("de-CH", {
                    day: "numeric",
                    month: "short",
                  })}
                </span>
                <span className="slot-picker-day-cell-plus" aria-hidden="true">
                  +
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
}
